import { render, staticRenderFns } from "./ConfirmContributionPage.vue?vue&type=template&id=9ccacaa2"
import script from "./ConfirmContributionPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmContributionPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports